export const SET_LOADING_REPORT_DATA = 'reporting/SET_LOADING_REPORT_DATA';
export const SET_REPORT_HTML = 'reporting/SET_REPORT_HTML';
export const SET_PLAN_TYPE = 'reporting/SET_PLAN_TYPE';
export const SET_REPORT_SUB_TYPE = 'reporting/SET_REPORT_SUB_TYPE';
export const SET_ORGANISATION_EXPORT = 'reporting/SET_ORGANISATION_EXPORT';
export const SET_SELECTED_REPORT_CLIENT =
  'reporting/SET_SELECTED_REPORT_CLIENT';
export const SET_REPORT_PENSION_SCHEMES =
  'reporting/SET_REPORT_PENSION_SCHEMES';
export const SET_GENERATED_REPORT_DETAILS =
  'reporting/SET_GENERATED_REPORT_DETAILS';
export const SET_REPORTS = 'reporting/SET_REPORTS';
export const SET_REPORT_REPORTING_PERIOD =
  'reporting/SET_REPORT_REPORTING_PERIOD';
export const SET_REPORT_COMMENTS = 'reporting/SET_REPORT_COMMENTS';
export const SET_EXPOSED_SUB_FUNDS = 'reporting/SET_EXPOSED_SUB_FUNDS';
export const SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS =
  'reporting/SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS';
export const SET_QUEUED_REPORTS = 'reporting/SET_QUEUED_REPORTS';
